import type { SVGProps } from 'react';

const SvgTextListNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5.82 6.98v2.31c0 .25.09.48.27.65.17.17.4.26.66.26s.49-.09.66-.25c.18-.17.28-.4.28-.65V5.42c0-.25-.09-.47-.25-.64-.15-.16-.46-.35-.94-.24-.12.03-.22.08-.31.14l-.96.64a.91.91 0 0 0-.44.77c0 .25.09.47.27.64.21.21.49.3.77.26zM7.99 18.1a.85.85 0 0 0-.62-.25h-.23l.06-.07c.28-.3.51-.63.67-.97.18-.37.27-.72.27-1.04 0-.38-.08-.72-.24-1.01-.17-.3-.41-.54-.71-.7-.44-.24-1.01-.33-1.6-.14-.19.06-.37.14-.54.25s-.33.23-.47.37c-.1.1-.18.19-.24.28a.9.9 0 0 0-.17.51c0 .24.1.46.29.63.25.23.58.3.91.19.15-.05.29-.15.4-.31.05-.06.1-.12.16-.17.05-.04.09-.07.19-.11.11 0 .14.03.15.05.02.02.06.06.06.2 0 .02 0 .1-.09.26-.08.15-.18.29-.31.44l-1.46 1.56c-.17.18-.26.4-.26.64s.08.45.24.62c.11.12.32.27.64.27h2.28c.24 0 .45-.08.62-.25.17-.16.26-.38.26-.62s-.09-.46-.25-.62zM10.5 7H18c.55 0 1-.45 1-1s-.45-1-1-1h-7.5c-.55 0-1 .45-1 1s.45 1 1 1M18 17h-7.5c-.55 0-1 .45-1 1s.45 1 1 1H18c.55 0 1-.45 1-1s-.45-1-1-1m0-6h-7.5c-.55 0-1 .45-1 1s.45 1 1 1H18c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTextListNumber;
